/* A premium feature upsell, as seen in the analytics nav.
 * Will also replace the search nav bar upsell soon.
 */
import React from 'react';
import styled from 'astroturf/react';

const Container = styled.div`
  padding: 28px;
  position: absolute;
  text-align: center;
  width: 330px;

  transition: opacity 0.15s linear;
  line-height: normal;
  font-weight: normal;
  position: absolute;
  left: calc(50% - 165px);
  z-index: 1060;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  white-space: normal;
  text-transform: none;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 14px;
  cursor: auto;
  margin-top: 10px;

  &:before {
    position: absolute;
    content: '';
    left: calc(50% - 4.5px);
    top: -9px;
    border-right: 9px solid transparent;
    border-bottom: 9px solid #ccc;
    border-left: 9px solid transparent;
  }

  &:after {
    position: absolute;
    top: -8px;
    left: calc(50% - 4.5px);
    content: '';
    border-right: 9px solid transparent;
    border-bottom: 9px solid #fff;
    border-left: 9px solid transparent;
  }
`;

const Title = styled.div`
  text-transform: uppercase;
  color: #999999;
  letter-spacing: 0.5px;
`;

const Body = styled.p`
  margin: 20px 0px;
  color: #333;
`;

const CtaButton = styled.button`
  height: 36px;
  line-height: 36px;
  font-size: 11px;
  padding: 0 18px;
  letter-spacing: 1.15px;
  background-color: #0954d3;
  color: #fff;
  position: relative;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  font-weight: bold;
  transition: color 0.25s ease background-color 0.25s ease;
`;

type Props = {
  show: boolean; // hides/shows the upsell with fade in/out
  bodyText: string;
  buttonUrl: string;
  buttonText?: string; // defaults to 'Learn More'
};

// todo: track impressions
const PremiumUpsellPopover = ({
  show,
  bodyText,
  buttonText,
  buttonUrl,
}: Props) => (
  <Container
    style={{ opacity: show ? 1 : 0, pointerEvents: show ? 'auto' : 'none' }}
  >
    <Title>Academia Premium Feature</Title>
    <Body>{bodyText}</Body>
    <CtaButton onClick={() => (window.location.href = buttonUrl)}>
      {buttonText ?? 'Learn More'}
    </CtaButton>
  </Container>
);

export default PremiumUpsellPopover;
